import { style } from 'typestyle'
import Vue from 'vue'
import prop from 'vue-strict-prop'
import { component, modifiers as m } from 'vue-tsx-support'
import { VNode } from 'vue/types/umd'

export default component({
	name: 'HeaderFilterInput',
	props: {
		value: prop(String).required,
	},
	data() {
		return {
			isExpanded: false,
		}
	},
	methods: {
		collapse(): void {
			this.isExpanded = false
		},
		expand(): void {
			this.isExpanded = true
			Vue.nextTick(() => {
				const el = this.$refs['input'] as HTMLInputElement
				el.value = this.value
				el.focus()
				el.setSelectionRange(0, this.value.length)
			})
		},
	},
	render(): VNode {
		return this.isExpanded ?
			<div>
				<div class="ui inverted left icon input">
					<input
						class="prompt"
						onBlur={this.collapse}
						onInput={e => this.$emit('input', e.target.value)}
						onKeyup={m.enter(this.collapse)}
						placeholder="Filter..."
						ref="input"
						type="text"
						/>
					<i class="filter link icon" />
				</div>
			</div>
			:
			<div class="link" onClick={this.expand}>
				<i class={['filter icon', { 'yellow': !!this.value }]} />
				{this.value &&
					<span class={styleValue}>
						&ldquo;{this.value}&rdquo;
					</span>
				}
			</div>
	},
})

const styleValue = style({
	color: '#fbbd08',
	fontStyle: 'italic',
})
